var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"easy-safe-item"},[_c('div',{staticClass:"img-wrap"},[_c('img',{attrs:{"src":_vm.obj.img}}),_c('div',{staticClass:"blur",class:{
        'blur-1': _vm.obj.id === 0,
        'blur-2': _vm.obj.id === 1,
        'blur-3': _vm.obj.id === 2,
        'blur-4': _vm.obj.id === 3,
        'blur-5': _vm.obj.id === 4,
      }})]),_c('div',{staticClass:"text-wrap"},[_c('div',{staticClass:"text",class:{ plus: _vm.isKeyPlaPlus, color: _vm.obj.id === 3 || _vm.obj.id === 4 }},[_vm._v(" "+_vm._s(_vm.obj.text1)+" ")]),_c('div',{staticClass:"text text-2",class:{ plus: _vm.isKeyPlaPlus }},[_vm._v(" "+_vm._s(_vm.obj.text2)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }